import React from 'react';
import { Modal, Button, Typography, Space } from 'antd';
import { CalendarClock, ShieldCheck, RefreshCw, CheckCircle2 } from 'lucide-react';

const { Title, Text, Paragraph } = Typography;

/**
 * Aviso informativo: o Open Finance mudou. Agora, ao final de cada mês,
 * capturamos automaticamente toda a movimentação do mês (não é mais em tempo
 * real). Voltado principalmente aos novos clientes.
 */
export default function OpenFinanceAvisoModal({ open, onClose }) {
    return (
        <Modal
            open={open}
            onCancel={onClose}
            footer={[
                <Button key="ok" type="primary" onClick={onClose}>
                    Entendi
                </Button>,
            ]}
            width={520}
            centered
            title={
                <Space>
                    <CalendarClock size={20} color="#4f46e5" />
                    <span style={{ fontWeight: 700 }}>Open Finance — como funciona agora</span>
                </Space>
            }
        >
            <div style={{ padding: '4px 0' }}>
                <Paragraph style={{ marginBottom: 16, color: '#475569' }}>
                    Deixamos o Open Finance ainda mais simples. Agora, <b>ao final de cada mês</b>,
                    reunimos automaticamente <b>toda a movimentação do mês</b> das suas contas
                    conectadas — como o extrato fechado do período, prontinho pra sua contabilidade.
                </Paragraph>

                <Space direction="vertical" size={12} style={{ width: '100%' }}>
                    <Linha
                        icon={<CalendarClock size={18} color="#4f46e5" />}
                        titulo="Automático no fim do mês"
                        texto="Nada de acompanhar ou sincronizar durante o mês. No fechamento, a movimentação entra sozinha."
                    />
                    <Linha
                        icon={<CheckCircle2 size={18} color="#16a34a" />}
                        titulo="Organizado e no lugar certo"
                        texto="Os lançamentos chegam completos e já classificados, prontos para a sua contabilidade."
                    />
                    <Linha
                        icon={<ShieldCheck size={18} color="#0ea5e9" />}
                        titulo="Conexão segura"
                        texto="A conexão com o banco é pelo Open Finance oficial, sempre com a sua autorização."
                    />
                    <Linha
                        icon={<RefreshCw size={18} color="#4f46e5" />}
                        titulo="Acabou de conectar um banco?"
                        texto="A movimentação dele aparece no próximo fechamento de mês. É só aguardar."
                    />
                </Space>
            </div>
        </Modal>
    );
}

function Linha({ icon, titulo, texto }) {
    return (
        <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
            <div style={{ marginTop: 2, flexShrink: 0 }}>{icon}</div>
            <div>
                <Text strong style={{ display: 'block', color: '#1e293b' }}>{titulo}</Text>
                <Text style={{ color: '#64748b', fontSize: 13 }}>{texto}</Text>
            </div>
        </div>
    );
}
